import { memo } from 'react';
import ReactDOM from 'react-dom';
const Portal = ({ children, target = document.body }) => ReactDOM.createPortal(children, target);
export default Object.assign(memo(Portal), { displayName: 'Portal' });
